import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';

const ExportModal = ({ exportApi, params, idParam = null, title = "Export Data" }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const toggleModal = () => {
    if (!isExporting) setIsModalOpen(!isModalOpen);
  };

  const handleExport = async () => {
    setIsExporting(true);
    try {
      let response
      if (idParam) {
        response = await exportApi(idParam, params);
      } else {
        response = await exportApi(params);
      }

      const blob = new Blob([response.data], {
        type: response.headers['content-type'],
      });
      const fileName = response.headers['content-disposition']?.split('filename=')[1]?.replace(/["]/g, '') || 'export.xlsx';

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Export completed");
      toggleModal();
    } catch (error) {
      console.error("Export failed", error);
      toast.error("Export failed. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };


  //   const handleExport = async () => {
  //     setIsExporting(true);
  //     try {
  //       await exportApi(params);
  //       toast.success("Export started or file downloaded successfully.");
  //       toggleModal();
  //     } catch (error) {
  //       const errMsg =
  //         error?.response?.data?.message ||
  //         "Something went wrong while exporting.";
  //       toast.error(errMsg);
  //     } finally {
  //       setIsExporting(false);
  //     }
  //   };

  return (
    <>
      {/* Export Button (Opens Modal) */}
      <button className="btn btn-outline-success" onClick={toggleModal} disabled={isExporting}>
        {isExporting ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            Exporting...
          </>
        ) : (
          <>
            <i className="fa-solid fa-download me-2" />
            Export
          </>
        )}
      </button>

      {/* Confirm Modal */}
      <Modal
        show={isModalOpen}
        onHide={toggleModal}
        centered
        backdrop="static"
        keyboard={!isExporting}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={toggleModal}
              disabled={isExporting}
            ></button>
          </div>
          <div className="modal-body">
            <p className="mb-0">
              Are you sure you want to export this data?
              <br />
              This may take a few seconds depending on the size.
            </p>
          </div>
          <div className="modal-footer">
            <Button
              variant="light"
              onClick={toggleModal}
              disabled={isExporting}
            >
              Cancel
            </Button>
            <Button
              variant="success"
              onClick={handleExport}
              disabled={isExporting}
            >
              {isExporting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Exporting...
                </>
              ) : (
                "Confirm & Export"
              )}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ExportModal;
